import * as React from "react"
import type { SVGProps } from "react"
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10.59 12 7.05 8.46a1 1 0 0 1-.3-.7q0-.4.3-.71t.7-.3q.42 0 .71.3L12 10.59l3.54-3.54q.3-.3.7-.3t.71.3.3.7q0 .42-.3.71L13.41 12l3.54 3.54q.3.3.3.7t-.3.71-.7.3a1 1 0 0 1-.71-.3L12 13.41l-3.54 3.54q-.3.3-.7.3a1 1 0 0 1-.71-.3 1 1 0 0 1-.3-.7q0-.41.3-.71z" />
  </svg>
)
export default SvgClose
